import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  id: "cmdMv"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_HomeListTitle = _resolveComponent("HomeListTitle");

  var _component_MvList = _resolveComponent("MvList");

  return _ctx.cmdMvList.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_HomeListTitle, {
    title: "推荐MV"
  }), _createVNode(_component_MvList, {
    mvList: _ctx.cmdMvList,
    isSonger: _ctx.cmdMvSonger,
    isBlod: true
  }, null, 8
  /* PROPS */
  , ["mvList", "isSonger"])])) : _createCommentVNode("v-if", true);
}